import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-eac23420"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "box card"
}
const _hoisted_2 = {
  key: 1,
  class: "animate"
}
const _hoisted_3 = { class: "card__title" }
const _hoisted_4 = { class: "card__apply" }
const _hoisted_5 = {
  class: "card__link",
  href: "#"
}

import { ref, onMounted } from 'vue'
import router from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'LessonList',
  props: ['content', 'alt'],
  setup(__props) {

const props = __props
const card = ref({
    id: 0,
    name: 'cargando...',
    description: 'cargando...',
    image_url: 'img/lms/loading.png',
})
const loading = ref(true)

onMounted(() => {
    loading.value = true
    card.value = props.content
    loading.value = false
})

const handleRoute = () => router.push({ name: 'course', params: { id: card.value.course_id, lesson_id: card.value.id } })

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          name: "ri-loader-2-fill",
          animation: "spin",
          class: "icon"
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass({'card':true, 'card-1': true, 'card-2': props.alt}),
          onClick: handleRoute
        }, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(props.content.name.substring(0,40)), 1),
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("a", _hoisted_5, [
              _createTextVNode("Ver clase "),
              _createVNode(_component_v_icon, {
                name: "bi-arrow-right-short",
                scale: "1.5",
                fill: "white"
              })
            ])
          ])
        ], 2)
      ]))
}
}

})